<template>
  <div class="product-view">
    <div class="header-box">
      <div class="header-line">
<!--        <el-button type="primary" size="small" @click="onQueryBtnClick">查询</el-button>-->
        <el-button type="primary" size="small" @click="onExportBtnClick" style="float: right;">导出</el-button>
      </div>
    </div>
    <el-table :data="tableData" border style="width: 100%;" size="small" cell-class-name="table-cell-normal"
              row-class-name="table-row-normal" header-cell-class-name="table-header-cell-normal">
      <el-table-column label="序号" width="45px">
        <template slot-scope="scope">
          <span class="ads-name" v-if="scope.$index != 0">{{beginIndex + scope.$index}}</span>
          <span v-if="scope.$index == 0">合计</span>
        </template>
      </el-table-column>
      <el-table-column prop="sellerSKU" label="sku" width="573px">
      </el-table-column>
      <el-table-column prop="sumDisposedQuantity" label="已完成数量" width="100px">
      </el-table-column>
      <el-table-column prop="sumInProcessQuantity" label="处理中数量" width="100px">
      </el-table-column>
      <el-table-column prop="purchaseCost" label="采购均价" width="100px">
      </el-table-column>
      <el-table-column prop="toFreight" label="头程运费均价" width="100px">
      </el-table-column>
      <el-table-column prop="sumRemovalFee" label="遗弃费用" width="100px">
      </el-table-column>
      <el-table-column prop="totalCost" label="遗弃总成本" width="100px">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import {
    removalReportModules
  } from '@r'
  import utils from '../../utils/utils.js'
  export default {
    props: {
      country: {
        type: String
      }
    },
    data() {
      return {
        asin: null,
        sku: null,
        date: [null, null],
        status: null,
        dsTimeZone: 1,
        oldTableData: [],
        beginIndex: 0,
      }
    },
    activated() {
      this.listAmazonProductGroupByAsin();
    },
    created(){
      this.asin=this.$route.query.asin;
    },
    methods: {

      onExportBtnClick(){
        let sku = this.sku?  "&sku=" + this.sku : "";
        let asin = this.asin? "&asin=" + this.asin : "";
        let status = this.status? "&status=" + this.status : "";
        window.open("/api/amazonRemovalReport/export?&country="+this.country);
      },

      listAmazonProductGroupByAsin() {
        removalReportModules.list({
          "asin": this.asin,
          "sellerSku": this.sku,
          "beginDate": this.date[0],
          "endDate": this.date[1],
          "dsTimeZone": this.dsTimeZone,
          'country': this.country,
        }).then((res) => {
          if (res.result !== 1) {
            this.$message({
              type: 'error',
              message: res.message ? res.message : '获取列表失败'
            });
            return
          }

          this.oldTableData = res.ldata;
          this.currentPage = this.beginIndex / this.pageSize + 1;
          if (this.oldTableData.length >= this.pageSize) {
            this.oldTableData.pop();
            this.oldTableData = this.currentPage + 1;
          }
        }).catch((err) => {
          this.$message({
            type: 'error',
            message: err.message ? err.message : '未知错误'
          });
        })
      },

    },
    computed: {
      tableData (){
        let newtable = this.oldTableData;
        return newtable;
      },
      user () {
        let userInfo = this.$store.state.userInfo;
        if(userInfo == null){
          this.$store.dispatch('REFRESH_USER_INFO').then((res) => {
            console.log(res);
          }).catch((err) => {
            console.log(err);
          })
        }
        return this.$store.state.userInfo || {};
      },
    }
  }
</script>

<style lang="scss">
  .no-padding{
    padding: 0px !important;
    .cell{
      padding: 0px !important;
    }
  }
  .exchange-rate-box{
    border-left: 1px solid #EBEEF5;
    border-right: 1px solid #EBEEF5;
    border-top: 1px solid #EBEEF5;
    padding: 10px;
  }
</style>
